import { useMemo } from 'react'
import { Select } from '@workwhile/ui'
import { usePulseContext } from '../context/PulseProvider'
import { track } from 'lib/amplitude'

export function CompaniesSelector() {
  const {
    state: { filters, companies, isCompaniesLoading },
    actions: { setFilters },
  } = usePulseContext()

  const selectedCompanies = useMemo(() => {
    const selectedIdsSet = new Set(filters.companyIds)
    return companies?.filter((c) => selectedIdsSet.has(c.value))
  }, [companies, filters.companyIds])

  return (
    <Select
      options={companies}
      isMulti
      value={selectedCompanies}
      placeholder={
        selectedCompanies?.length > 0
          ? `${selectedCompanies.length} selected locations`
          : 'Filter by Location'
      }
      isClearable={true}
      onChange={(newValue) => {
        track('button_click, pulse_filter_company', {
          companyIds: newValue?.map((v) => v.value) ?? [],
        })
        setFilters({
          ...filters,
          companyIds: newValue?.map((v) => v.value) ?? [],
        })
      }}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      controlShouldRenderValue={false}
      isLoading={isCompaniesLoading}
    />
  )
}
